import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { useBoolean } from "usehooks-ts";
import { ButtonPanel } from "../../../../../../../base/buttons/button/index.js";
import Input from "../../../../../input/index.js";
import Select from "../../../../../select/index.js";
import Inputs from "../../../../../../others/inputs/index.js";
import Modal from "../../../../../../../structures/others/modal/index.js";
import { nullFunction } from "../../../../../../../../helpers/null.js";
import useLocation from "../../../../hooks/useLocation.js";
import * as SS from "../../styled.js";
const LocationSelectMobile = (props)=>{
    const { literals , origin , destination  } = props;
    const { selectedTab , setSelectedTab , showButton , setShowButton , handleOnMouseDownOrigin , handleOnMouseDownDestination  } = useLocation();
    const { value: isVisible , toggle: toggleVisibility  } = useBoolean();
    const currentOrigin = useRef(origin.value);
    const currentDestination = useRef(destination.value);
    const onOpen = useCallback(()=>{
        toggleVisibility();
        currentOrigin.current = origin.value;
        currentDestination.current = destination.value;
    }, [
        destination.value,
        origin.value,
        toggleVisibility
    ]);
    const onClose = useCallback(()=>{
        toggleVisibility();
        origin.onChange?.(currentOrigin.current, {
            action: 'select-option',
            option: currentOrigin.current
        });
        destination.onChange?.(currentDestination.current, {
            action: 'select-option',
            option: currentDestination.current
        });
    }, [
        destination,
        origin,
        toggleVisibility
    ]);
    const onConfirm = useCallback(()=>{
        toggleVisibility();
    }, [
        toggleVisibility
    ]);
    useEffect(()=>{
        if (origin.value !== currentOrigin.current || destination.value !== currentDestination.current) {
            if (origin.value && destination.value) setShowButton(true);
            setSelectedTab(1);
        }
    }, [
        destination.value,
        origin.value,
        setSelectedTab,
        setShowButton
    ]);
    const originSelectRef = useRef(null);
    const destinationSelectRef = useRef(null);
    const finalTabs = [
        {
            index: 0,
            label: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SS.LocationTabLabel, {
                        children: origin.placeholder
                    }),
                    /*#__PURE__*/ _jsx(SS.LocationTabLabelContent, {
                        children: origin.value?.label ?? literals?.tabContentOrigin
                    })
                ]
            }),
            element: /*#__PURE__*/ _jsx("div", {
                ref: originSelectRef,
                children: /*#__PURE__*/ _jsx(Select, {
                    variant: "without-modal",
                    menuPortalTarget: originSelectRef.current,
                    ...origin
                })
            })
        },
        {
            index: 1,
            label: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SS.LocationTabLabel, {
                        children: destination.placeholder
                    }),
                    /*#__PURE__*/ _jsx(SS.LocationTabLabelContent, {
                        children: destination.value?.label ?? literals?.tabContentDestination
                    })
                ]
            }),
            element: /*#__PURE__*/ _jsx("div", {
                ref: destinationSelectRef,
                children: /*#__PURE__*/ _jsx(Select, {
                    variant: "without-modal",
                    menuPortalTarget: destinationSelectRef.current,
                    ...destination
                })
            })
        }
    ];
    const LocationTabs = /*#__PURE__*/ _jsx(SS.LocationTabs, {
        selectedTab: selectedTab,
        onClick: setSelectedTab,
        tabs: finalTabs,
        color: 'primary'
    });
    const LocationButtonModal = /*#__PURE__*/ _jsx(ButtonPanel, {
        variant: "secondary",
        onClick: onConfirm,
        $fullWidth: true,
        children: literals?.accept
    });
    return /*#__PURE__*/ _jsxs("div", {
        id: "location",
        "data-testid": "Location",
        children: [
            /*#__PURE__*/ _jsxs(Inputs, {
                children: [
                    /*#__PURE__*/ _jsxs(SS.LocationItem, {
                        onClick: onOpen,
                        children: [
                            /*#__PURE__*/ _jsx(Input, {
                                type: "button",
                                label: origin.placeholder,
                                icon: "",
                                value: origin.value?.label ?? literals?.originLabel ?? '',
                                onChange: nullFunction,
                                autoComplete: "off",
                                disableInternalFocus: true,
                                onMouseDown: handleOnMouseDownOrigin,
                                "data-testid": "LocationOriginInput",
                                error: origin.error,
                                hasError: origin.hasError,
                                isFocused: isVisible
                            }),
                            /*#__PURE__*/ _jsx(SS.LocationInputIcon, {
                                children: /*#__PURE__*/ _jsx("i", {
                                    className: "nico-arrow-right"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SS.LocationItem, {
                        onClick: onOpen,
                        children: /*#__PURE__*/ _jsx(Input, {
                            type: "button",
                            label: destination.placeholder,
                            icon: "",
                            value: destination.value?.label ?? literals?.destinationLabel ?? '',
                            onChange: nullFunction,
                            autoComplete: "off",
                            disableInternalFocus: true,
                            onMouseDown: handleOnMouseDownDestination,
                            "data-testid": "LocationDestinationInput",
                            error: destination.error,
                            hasError: destination.hasError,
                            isFocused: isVisible
                        })
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ _jsx(Modal, {
                visible: isVisible,
                hide: onClose,
                header: literals?.locationTitle,
                content: LocationTabs,
                variant: 'fullScreen',
                color: 'primary',
                footer: showButton ? LocationButtonModal : undefined
            })
        ]
    });
};
export default LocationSelectMobile;

//# sourceMappingURL=index.js.map